import { IdentificationComponent } from './identification.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IdentificationInfoComponent } from './identification-info/identification-info.component';

const routes: Routes = [
  {path: '', component: IdentificationComponent},
  { path: 'detail/:id' , component: IdentificationInfoComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IdentificationRoutingModule { }
